import { Build } from '@todesktop/shared';
import findAppUserId from './findAppUserId';
import getBuildById from './getBuildById';
import getProjectConfig from './projectConfig/getProjectConfig';
import { currentUser } from './firestore';

export default async function getBuildAttributes({
  buildId,
  configPath,
}: {
  buildId: string;
  configPath?: string;
}): Promise<BuildAttributes> {
  const {
    id: appId,
    nodeVersion,
    npmVersion,
    pnpmVersion,
    bunVersion,
  } = getProjectConfig(configPath).config;
  const { id: userId } = await findAppUserId(appId);
  const contextUserId = currentUser()?.uid;
  const build = await fetchBuild({ appId, buildId, userId });

  return {
    appId,
    build,
    buildId,
    contextUserId,
    nodeVersion,
    npmVersion,
    pnpmVersion,
    bunVersion,
    userId,
  };
}

async function fetchBuild({
  appId,
  buildId,
  userId,
}: {
  appId: string;
  buildId: string;
  userId: string;
}): Promise<Build> {
  const build = await getBuildById({ appId, buildId, userId });
  if (!build) {
    throw new Error(`No such build ${buildId} for application ${appId}`);
  }

  return build;
}

interface BuildAttributes {
  appId: string;
  buildId: string;
  build: Build;
  bunVersion?: string;
  contextUserId?: string;
  nodeVersion?: string;
  npmVersion?: string;
  pnpmVersion?: string;
  userId: string;
}
